@if (showChatBubble) {
  <div class="chat-bubble" [cdkDragConstrainPosition]="dragConstrainPoint"  cdkDrag (cdkDragStarted)="dragStart()"
    (cdkDragReleased)="dragReleased($event)" (click)="openChat($event)">
    <img src="{{ DEPLOY_URL }}/assets/images/chat-message.svg" />
  </div>
}
@if (showDropZone) {
  <div class="close-chat-bubble">
    <div #dropZone class="drag-zone">
      <img src="{{ DEPLOY_URL }}/assets/images/delete-white.svg" class="drag-icon" />
      <span class="drag-text"> Drag here to Dismiss </span>
    </div>
  </div>
}